export default {
  "psi": {
    "value": "psi",
    "label": "PSI",
    "abbreviation": "PSI",
    "toBase": function(value) {
      return value/1;
    },
    "toDisplay": function(value) {
      return value/1;
    }
  }
}
